"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREDIT_LINE_BILLING_PERIOD_DURATION = exports.CREDIT_LINE_BILLING_PERIOD_OPTIONS = exports.CREDIT_LINE_PERIOD_UNIT_DESCRIPTIVE = exports.CreditLinePeriodUnit = void 0;
var CreditLinePeriodUnit;
(function (CreditLinePeriodUnit) {
    CreditLinePeriodUnit[CreditLinePeriodUnit["Week"] = 0] = "Week";
    CreditLinePeriodUnit[CreditLinePeriodUnit["Month"] = 1] = "Month";
})(CreditLinePeriodUnit || (exports.CreditLinePeriodUnit = CreditLinePeriodUnit = {}));
exports.CREDIT_LINE_PERIOD_UNIT_DESCRIPTIVE = {
    [CreditLinePeriodUnit.Week]: "week",
    [CreditLinePeriodUnit.Month]: "month",
};
exports.CREDIT_LINE_BILLING_PERIOD_OPTIONS = {
    one_week: "1 week",
    two_weeks: "2 weeks",
    one_month: "1 month",
};
exports.CREDIT_LINE_BILLING_PERIOD_DURATION = {
    [exports.CREDIT_LINE_BILLING_PERIOD_OPTIONS.one_week]: { periodLength: 1, periodUnit: CreditLinePeriodUnit.Week },
    [exports.CREDIT_LINE_BILLING_PERIOD_OPTIONS.two_weeks]: { periodLength: 2, periodUnit: CreditLinePeriodUnit.Week },
    [exports.CREDIT_LINE_BILLING_PERIOD_OPTIONS.one_month]: { periodLength: 1, periodUnit: CreditLinePeriodUnit.Month },
};
//# sourceMappingURL=period-unit.enum.js.map